import styles from './Projects.module.css';
import { useEffect, useState } from 'react';
import data from '../data.json';
import Card from './Card';

function Projects() {
    const [items, setItems] = useState([]);

    useEffect(() => {
        setItems(data.list);
    }, []);

    return (
        <article className={styles.block} id='works'>
            <h3 className={styles.title}>Работы</h3>
            <div className={styles.cards}>
                <div className={styles.rightBlock}>
                    <p className={styles.text}>
                        Все картины выполнены в технике классной. Используются только качественные краски.
                        Все работы покрыты лаком. Смотреть на них одно удовольствие.
                    </p>
                    <div className={styles.cardBlock}>
                        {items.length > 0 &&
                            items
                                .filter(item => Number(item.id) % 2 === 0)
                                .map(item => <Card item={item} key={item.id} />)
                        }
                    </div>
                </div>
                <div className={styles.cardBlock}>
                    {items.length > 0 &&
                        items
                            .filter(item => Number(item.id) % 2 !== 0)
                            .map(item => <Card item={item} key={item.id} />)
                    }
                </div>
            </div>
        </article>
    );
}

export default Projects;
